import { Controller } from "@hotwired/stimulus"

import Dropzone from "dropzone";
import { DirectUpload } from "@rails/activestorage";
import {
  findElement,
  removeElement,
  insertAfter,
} from "../helpers/dropzone";

export default class extends Controller {
  static targets = ['image'];

  connect() {

    // DropZone
    console.log('DropZone: ', this.imageTarget);
    this.dropZone = createDropZone(this);
    this.hideFileInput();
    this.bindDZEvents();
    
  }

  csrfToken() {
    const metaTag = document.querySelector('meta[name="csrf-token"]')
    return metaTag ? metaTag.content : ''
  }

  hideFileInput() {
    this.imageTarget.style.display = 'none';
    this.imageTarget.disabled = true;
  }

  async destroyBlob(id) {
    const response = await fetch('/drop_zone/remove_blob/' + id + '?format=json', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken(),
      },
      body: JSON.stringify({blob: { id: id }})
    });
    return response.json();
  }

  bindDZEvents() {
    this.dropZone.on("addedfile", (file) => {
      // console.log('addedFile: ', file);
      setTimeout(() => {
        file.accepted && createDirectUploadController(this, file).start();
      }, 500);
    });

    this.dropZone.on("removedfile", (file) => {
      // console.log('removedfile: ', file);
      if(file.controller){
        let id = file.controller.hiddenInput.value;
        removeElement(file.controller.hiddenInput);
        this.destroyBlob(id).then((data) => {
          // console.log("result: ", data);
        });
      }
    });
    this.dropZone.on("canceled", (file) => {
      file.controller && file.controller.xhr.abort();
    });
    this.dropZone.on("processing", (file) => {
      // this.submitButton.disabled = true;
      console.log('Processing: ', file);
    });
    this.dropZone.on("queuecomplete", (file) => {
      // this.submitButton.disabled = false;
      console.log('QueueComplete: ', file);
    });
  }

  toggleUploader() {
    document.getElementById('item-main-image').classList.toggle('hidden');
    document.getElementById('item-dz-uploader').classList.toggle('hidden');
  }

  get headers() {
    return { 'X-CSRF-Token': this.csrfToken() };
  }
  get url() {
    return this.imageTarget.getAttribute("data-direct-upload-url");
  }
  get maxFiles() {
    // return this.data.get("maxFiles") || 1;
    return this.imageTarget.getAttribute("data-dropzone-max-files") || 1;
  }
  get maxFileSize() {
    console.log('maxFileSize: ', this.imageTarget.getAttribute("data-dropzone-max-file-size"));
    // return this.data.get("maxFileSize") || 1;
    return this.imageTarget.getAttribute("data-dropzone-max-file-size") || 1;
  }
  get acceptedFiles() {
    return this.imageTarget.getAttribute("data-accepted-multiple")
  }
  get addRemoveLinks() {
    return this.data.get("addRemoveLinks") || true;
  }
  get uploadMultiple() {
    // return this.data.get("uploadMultiple") || false;
    return this.imageTarget.getAttribute("data-upload-multiple") || false;
  }
  get thumbnailWidth() {
    // return this.data.get("thumbnailWidth") || null;
    return this.imageTarget.getAttribute("data-thumbnail-width") || null;
  }
  get thumbnailHeight() {
    // return this.data.get("thumbnailHeight") || null;
    return this.imageTarget.getAttribute("data-thumbnail-height") || null;
  }
  get autoQueue(){
    // return this.data.get("autoQueue") || false;
    // return this.imageTarget.getAttribute("data-auto-queue") || false;
    false;
  }
}

class DirectUploadController {
  constructor(source, file) {
    this.directUpload = createDirectUpload(file, source.url, this);
    this.source = source;
    this.file = file;
  }
  start(){
    this.file.controller = this;
    this.hiddenInput = this.createHiddenInput();
    this.directUpload.create((error, attributes) => {
      if (error) {
        removeElement(this.hiddenInput);
        this.emitDropZoneError(error);
      } else {
        this.hiddenInput.value = attributes.id;
        this.emitDropZoneSuccess();
      }
    });
  }
  createHiddenInput() {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = this.source.imageTarget.name;
    insertAfter(input, this.source.imageTarget);
    return input;
  }
  directUploadWillStoreFileWithXHR(xhr){
    this.bindProgressEvent(xhr);
    this.emitDropZoneUploading();
  }
  bindProgressEvent(xhr){
    this.xhr = xhr;
    this.xhr.upload.addEventListener('progress', (event) => this.uploadRequestProgess(event));
  }
  uploadRequestProgess(event){
    const element = this.source.element;
    const progress = event.loaded /event.total * 100;
    findElement(this.file.previewTemplate, '.dz-upload').style.width = `${progress}%`;
  }
  emitDropZoneUploading(){
    this.file.status = Dropzone.UPLOADING;
    this.source.dropZone.emit('processing', this.file);
  }
  emitDropZoneError(error) {
    this.file.status = Dropzone.ERROR;
    this.source.dropZone.emit("error", this.file, error);
    this.source.dropZone.emit("complete", this.file);
  }
  emitDropZoneSuccess() {
    this.file.status = Dropzone.SUCCESS;
    this.source.dropZone.emit("success", this.file);
    this.source.dropZone.emit("complete", this.file);
  }
}


function createDirectUploadController(source, file) {
  return new DirectUploadController(source, file);
}

function createDirectUpload(file, url, controller) {
  return new DirectUpload(file, url, controller);
}

function createDropZone(controller){
  // console.log('dropzone: ', controller.element);
  // console.log('maxFiles: ', controller.maxFiles);
  // console.log('maxFilesize: ', controller.maxFilesize);
  // console.log('uploadMultiple: ', controller.uploadMultiple);
  // console.log('autoQueue: ', controller.autoQueue);

  let dropzone = new Dropzone(controller.element.getElementsByClassName('dropzone')[0], {
    url: controller.url,
    headers: controller.headers,
    maxFiles: controller.maxFiles,
    maxFilesize: controller.maxFileSize,
    acceptedFiles: controller.acceptedFiles,
    addRemoveLinks: controller.addRemoveLinks,
    uploadMultiple: controller.uploadMultiple,
    thumbnailWidth: controller.thumbnailWidth,
    thumbnailHeight: controller.thumbnailHeight,
    autoQueue: controller.autoQueue,
  });
  return dropzone;
}